export default {
  apiKey: 'AIzaSyBf3mL_CJtGJPVzyaitz88a5cwwx-NDpAQ',
  authDomain: 'nashicorp-c4055.firebaseapp.com',
  databaseURL: 'https://nashicorp-c4055.firebaseio.com',
  projectId: 'nashicorp-c4055',
  storageBucket: 'nashicorp-c4055.appspot.com',
  messagingSenderId: '774202403358',
};



// WEBPACK FOOTER //
// ./src/firebase/config.js